import Message from '@admin/components/message'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Verify extends React.Component {

  static propTypes = {
    onNext: PropTypes.func
  }

  state = {
    resend: false
  }

  _handleFailure = this._handleFailure.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      title: 't(Mobile Phone)',
      action: '/api/admin/account/mobile/verify',
      method: 'POST',
      saveText: 't(Next)',
      cancelText: null,
      cancelSvg: 'chevron_left',
      onFailure: this._handleFailure,
      onSuccess: this._handleSuccess,
      before: <Message { ...this._getMessage() } />,
      sections: [
        {
          fields: [
            { name: 'code', type: 'numberfield', placeholder: 't(Enter Verification Code)', maxLength: 6, required: true }
          ]
        }
      ]
    }
  }

  _getMessage() {
    return {
      icon: 'hashtag',
      backgroundColor: 'darkblue',
      title: 't(Verify Mobile Phone)',
      text: 't(Enter your verification code)'
    }
  }

  _handleFailure() {
    this.setState({
      resend: true
    })
  }

  _handleSuccess() {
    this.props.onNext()
  }

}

export default Verify
